import { A1 } from '../styled_components/Storage/Icons/A1';
import { A2 } from '../styled_components/Storage/Icons/A2';
import { A3 } from '../styled_components/Storage/Icons/A3';
import { A4 } from '../styled_components/Storage/Icons/A4';
import { A5 } from '../styled_components/Storage/Icons/A5';
import { A6 } from '../styled_components/Storage/Icons/A6';
import { A7 } from '../styled_components/Storage/Icons/A7';

import { B1 } from '../styled_components/Storage/Icons/B1';
import { B2 } from '../styled_components/Storage/Icons/B2';
import { B3 } from '../styled_components/Storage/Icons/B3';
import { B4 } from '../styled_components/Storage/Icons/B4';
import { B5 } from '../styled_components/Storage/Icons/B5';
import { B6 } from '../styled_components/Storage/Icons/B6';
import { B7 } from '../styled_components/Storage/Icons/B7';

import { C1 } from '../styled_components/Storage/Icons/C1';
import { C2 } from '../styled_components/Storage/Icons/C2';
import { C3 } from '../styled_components/Storage/Icons/C3';
import { C4 } from '../styled_components/Storage/Icons/C4';
import { C5 } from '../styled_components/Storage/Icons/C5';
import { C6 } from '../styled_components/Storage/Icons/C6';
import { C7 } from '../styled_components/Storage/Icons/C7';

import { D1 } from '../styled_components/Storage/Icons/D1';
import { D2 } from '../styled_components/Storage/Icons/D2';
import { D3 } from '../styled_components/Storage/Icons/D3';
import { D4 } from '../styled_components/Storage/Icons/D4';
import { D5 } from '../styled_components/Storage/Icons/D5';
import { D6 } from '../styled_components/Storage/Icons/D6';
import { D7 } from '../styled_components/Storage/Icons/D7';

import { E1 } from '../styled_components/Storage/Icons/E1';
import { E2 } from '../styled_components/Storage/Icons/E2';
import { E3 } from '../styled_components/Storage/Icons/E3';
import { E4 } from '../styled_components/Storage/Icons/E4';
import { E5 } from '../styled_components/Storage/Icons/E5';
import { E6 } from '../styled_components/Storage/Icons/E6';
import { E7 } from '../styled_components/Storage/Icons/E7';

import { F1 } from '../styled_components/Storage/Icons/F1';
import { F2 } from '../styled_components/Storage/Icons/F2';
import { F3 } from '../styled_components/Storage/Icons/F3';
import { F4 } from '../styled_components/Storage/Icons/F4';
import { F5 } from '../styled_components/Storage/Icons/F5';
import { F6 } from '../styled_components/Storage/Icons/F6';
import { F7 } from '../styled_components/Storage/Icons/F7';

export const TYPES = {
	BILLING: 'BILLING',
	OUTAGE: 'OUTAGE',
	SUPPORT: 'SUPPORT',
	STORAGE: 'STORAGE',
	BUG: 'BUG',
	FEATURE: 'FEATURE',
	IMPROVEMENT: 'IMPROVEMENT',
	OTHER: 'OTHER',
};

export const STORAGE_ICONS = {
	a1: A1,
	a2: A2,
	a3: A3,
	a4: A4,
	a5: A5,
	a6: A6,
	a7: A7,
	b1: B1,
	b2: B2,
	b3: B3,
	b4: B4,
	b5: B5,
	b6: B6,
	b7: B7,
	c1: C1,
	c2: C2,
	c3: C3,
	c4: C4,
	c5: C5,
	c6: C6,
	c7: C7,
	d1: D1,
	d2: D2,
	d3: D3,
	d4: D4,
	d5: D5,
	d6: D6,
	d7: D7,
	e1: E1,
	e2: E2,
	e3: E3,
	e4: E4,
	e5: E5,
	e6: E6,
	e7: E7,
	f1: F1,
	f2: F2,
	f3: F3,
	f4: F4,
	f5: F5,
	f6: F6,
	f7: F7,
};

export const SEVERITIES = {
	LOW: 'LOW',
	MEDIUM: 'MEDIUM',
	HIGH: 'HIGH',
	URGENT: 'URGENT',
};

export const MENU = {
	OVERVIEW: 'OVERVIEW',
	MANAGE: 'MANAGE STORAGE',
	ADD_STORAGE: 'ADD STORAGE',
	DELETE_STORAGE: 'DELETE STORAGE',
	DETAIL: 'SHARE DETAIL',
};

export const FIELDS = {
	LOCATION: 'Primary Location',
	SECONDARY_LOCATION: 'Secondary Location',
	ACCESSIBILITY: 'Accessibility',
	NAME: 'Storage Name',
	TYPE: 'Type',
	REDUNDANT: 'Redundant ?',
	WHITELIST: 'Whitelist Subnet',
};

export const STORAGE_MESSAGE = {
	START: 'Need to setup another share?  ',
	CONTENT: "If you give us the details, we'll get another share setup for you ASAP!",
};

export const PASSWORD_UPDATE_STATUS = {
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR',
	NOT_STARTED: 'NOT_STARTED',
};

export const SAMPLE_SHARE = {
	NAME: 'SHARE NAME',
	LOCATION: 'ATLANTA',
	TYPE: 'FILE ACCESS',
	VLAN: '1111',
	ACCESSIBILITY: 'PUBLIC',
	ASSIGNED_IP: 'ASSIGNED IP',
	WHITELIST: 'WHITELIST SUBNET',
};

export const LAYOUT_GRID_SHARE_DETAILS = {
	xs: [
		{ i: 'share-name-label', x: 1, y: 1, w: 3, h: 1.5, static: true },
		{ i: 'share-config', x: 1, y: 3, w: 5, h: 12, static: true },
		{ i: 'share-path-label', x: 1, y: 12, w: 2, h: 1.5, static: true },
		{ i: 'network-config', x: 1, y: 19, w: 5, h: 8, static: true },
		{ i: 'trending-label', x: 6, y: 1, w: 2, h: 1.5, static: true },
		{ i: 'access', x: 5, y: 1, w: 1, h: 1.5, static: true },
		{ i: 'horizontal-bar', x: 0, y: 30, w: 10, h: 1, static: true },
		{ i: 'trend-graph-label', x: 1, y: 5, w: 2, h: 1.5, static: true },
		{ i: 'trend-graph', x: 1, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'network-graph-label', x: 5.5, y: 5, w: 3, h: 1.5, static: true },
		{ i: 'network-graph', x: 5.5, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'share-graph-label', x: 5.5, y: 18, w: 3, h: 1.5, static: true },
		{ i: 'share-graph', x: 5.5, y: 20, w: 4.5, h: 9, static: true },
		{ i: 'shares-label', x: 1, y: 32, w: 4, h: 1.5, static: true },
		{ i: 'shares', x: 1, y: 34, w: 7, h: 9, static: true },
		{ i: 'add-storage', x: 8.5, y: 34, w: 3, h: 9, static: true },
	],
	sm: [
		{ i: 'share-name-label', x: 1, y: 1, w: 3, h: 1.5, static: true },
		{ i: 'share-config', x: 1, y: 3, w: 5, h: 12, static: true },
		{ i: 'share-path-label', x: 1, y: 12, w: 2, h: 1.5, static: true },
		{ i: 'network-config', x: 1, y: 19, w: 5, h: 8, static: true },
		{ i: 'trending-label', x: 6, y: 1, w: 2, h: 1.5, static: true },
		{ i: 'access', x: 5, y: 1, w: 1, h: 1.5, static: true },
		{ i: 'horizontal-bar', x: 0, y: 30, w: 10, h: 1, static: true },
		{ i: 'trend-graph-label', x: 1, y: 5, w: 2, h: 1.5, static: true },
		{ i: 'trend-graph', x: 1, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'network-graph-label', x: 5.5, y: 5, w: 3, h: 1.5, static: true },
		{ i: 'network-graph', x: 5.5, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'share-graph-label', x: 5.5, y: 18, w: 3, h: 1.5, static: true },
		{ i: 'share-graph', x: 5.5, y: 20, w: 4.5, h: 9, static: true },
		{ i: 'shares-label', x: 1, y: 32, w: 4, h: 1.5, static: true },
		{ i: 'shares', x: 1, y: 34, w: 7, h: 9, static: true },
		{ i: 'add-storage', x: 8.5, y: 34, w: 3, h: 9, static: true },
	],
	md: [
		{ i: 'share-name-label', x: 1, y: 1, w: 3, h: 1.5, static: true },
		{ i: 'share-config', x: 1, y: 3, w: 5, h: 12, static: true },
		{ i: 'share-path-label', x: 1, y: 12, w: 2, h: 1.5, static: true },
		{ i: 'network-config', x: 1, y: 19, w: 5, h: 8, static: true },
		{ i: 'trending-label', x: 6, y: 1, w: 2, h: 1.5, static: true },
		{ i: 'access', x: 5, y: 1, w: 1, h: 1.5, static: true },
		{ i: 'horizontal-bar', x: 0, y: 30, w: 10, h: 1, static: true },
		{ i: 'trend-graph-label', x: 1, y: 5, w: 2, h: 1.5, static: true },
		{ i: 'trend-graph', x: 1, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'network-graph-label', x: 5.5, y: 5, w: 3, h: 1.5, static: true },
		{ i: 'network-graph', x: 5.5, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'share-graph-label', x: 5.5, y: 18, w: 3, h: 1.5, static: true },
		{ i: 'share-graph', x: 5.5, y: 20, w: 4.5, h: 9, static: true },
		{ i: 'shares-label', x: 1, y: 32, w: 4, h: 1.5, static: true },
		{ i: 'shares', x: 1, y: 34, w: 7, h: 9, static: true },
		{ i: 'add-storage', x: 8.5, y: 34, w: 3, h: 9, static: true },
	],
	lg: [
		{ i: 'share-name-label', x: 1, y: 1, w: 3, h: 1.5, static: true },
		{ i: 'share-config', x: 1, y: 3, w: 5, h: 12, static: true },
		{ i: 'share-path-label', x: 1, y: 12, w: 2, h: 1.5, static: true },
		{ i: 'network-config', x: 1, y: 19, w: 5, h: 8, static: true },
		{ i: 'trending-label', x: 6, y: 1, w: 2, h: 1.5, static: true },
		{ i: 'access', x: 5, y: 1, w: 1, h: 1.5, static: true },
		{ i: 'horizontal-bar', x: 0, y: 30, w: 10, h: 1, static: true },
		{ i: 'trend-graph-label', x: 1, y: 5, w: 2, h: 1.5, static: true },
		{ i: 'trend-graph', x: 1, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'network-graph-label', x: 5.5, y: 5, w: 3, h: 1.5, static: true },
		{ i: 'network-graph', x: 5.5, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'share-graph-label', x: 5.5, y: 18, w: 3, h: 1.5, static: true },
		{ i: 'share-graph', x: 5.5, y: 20, w: 4.5, h: 9, static: true },
		{ i: 'shares-label', x: 1, y: 32, w: 4, h: 1.5, static: true },
		{ i: 'shares', x: 1, y: 34, w: 7, h: 9, static: true },
		{ i: 'add-storage', x: 8.5, y: 34, w: 3, h: 9, static: true },
	],
};

export const LAYOUT_GRID_MANAGE_STORAGE = {
	xs: [
		{ i: 'video', x: 1.5, y: 2, w: 9, h: 24, static: true },
		{ i: 'horizontal-bar', x: 0, y: 30, w: 10, h: 1, static: true },
		{ i: 'trend-graph-label', x: 1, y: 5, w: 2, h: 1.5, static: true },
		{ i: 'trend-graph', x: 1, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'network-graph-label', x: 5.5, y: 5, w: 3, h: 1.5, static: true },
		{ i: 'network-graph', x: 5.5, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'share-graph-label', x: 5.5, y: 20, w: 3, h: 1.5, static: true },
		{ i: 'share-graph', x: 5.5, y: 22, w: 4.5, h: 9, static: true },
		{ i: 'shares-label', x: 1, y: 32, w: 4, h: 1.5, static: true },
		{ i: 'shares', x: 1, y: 34, w: 7, h: 9, static: true },
		{ i: 'add-storage', x: 8.5, y: 34, w: 3, h: 9, static: true },
	],
	sm: [
		{ i: 'video', x: 1.5, y: 2, w: 9, h: 24, static: true },
		{ i: 'horizontal-bar', x: 0, y: 30, w: 10, h: 1, static: true },
		{ i: 'trend-graph-label', x: 1, y: 5, w: 2, h: 1.5, static: true },
		{ i: 'trend-graph', x: 1, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'network-graph-label', x: 5.5, y: 5, w: 3, h: 1.5, static: true },
		{ i: 'network-graph', x: 5.5, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'share-graph-label', x: 5.5, y: 20, w: 3, h: 1.5, static: true },
		{ i: 'share-graph', x: 5.5, y: 22, w: 4.5, h: 9, static: true },
		{ i: 'shares-label', x: 1, y: 32, w: 4, h: 1.5, static: true },
		{ i: 'shares', x: 1, y: 34, w: 7, h: 9, static: true },
		{ i: 'add-storage', x: 8.5, y: 34, w: 3, h: 9, static: true },
	],
	md: [
		{ i: 'video', x: 1.5, y: 2, w: 9, h: 24, static: true },
		{ i: 'horizontal-bar', x: 0, y: 30, w: 10, h: 1, static: true },
		{ i: 'trend-graph-label', x: 1, y: 5, w: 2, h: 1.5, static: true },
		{ i: 'trend-graph', x: 1, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'network-graph-label', x: 5.5, y: 5, w: 3, h: 1.5, static: true },
		{ i: 'network-graph', x: 5.5, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'share-graph-label', x: 5.5, y: 18, w: 3, h: 1.5, static: true },
		{ i: 'share-graph', x: 5.5, y: 20, w: 4.5, h: 9, static: true },
		{ i: 'shares-label', x: 1, y: 32, w: 4, h: 1.5, static: true },
		{ i: 'shares', x: 1, y: 34, w: 7, h: 9, static: true },
		{ i: 'add-storage', x: 8.5, y: 34, w: 3, h: 9, static: true },
	],
	lg: [
		{ i: 'video', x: 1.5, y: 2, w: 9, h: 24, static: true },
		{ i: 'horizontal-bar', x: 0, y: 30, w: 10, h: 1, static: true },
		{ i: 'trend-graph-label', x: 1, y: 5, w: 2, h: 1.5, static: true },
		{ i: 'trend-graph', x: 1, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'network-graph-label', x: 5.5, y: 5, w: 3, h: 1.5, static: true },
		{ i: 'network-graph', x: 5.5, y: 7, w: 4.5, h: 11, static: true },
		{ i: 'share-graph-label', x: 5.5, y: 20, w: 3, h: 1.5, static: true },
		{ i: 'share-graph', x: 5.5, y: 22, w: 4.5, h: 9, static: true },
		{ i: 'shares-label', x: 1, y: 32, w: 4, h: 1.5, static: true },
		{ i: 'shares', x: 1, y: 34, w: 7, h: 9, static: true },
		{ i: 'add-storage', x: 8.5, y: 34, w: 3, h: 9, static: true },
	],
};

export const LAYOUT_GRID = {
	xs: [
		{ i: 'add-storage-label', x: 1, y: 1, w: 3, h: 1.5, static: true },
		{ i: 'add-storage', x: 1, y: 3, w: 2, h: 7, static: true },
		{ i: 'storage-ticket-label', x: 4, y: 1, w: 3, h: 1, static: true },
		{ i: 'open-tickets', x: 4, y: 3, w: 2, h: 7, static: true },
		{ i: 'close-tickets', x: 6, y: 3, w: 2, h: 7, static: true },
		{ i: 'share-list-label', x: 7, y: 13, w: 2, h: 1, static: true },
		{ i: 'storage-graphs', x: 1, y: 13, w: 6, h: 34, static: true },
		{ i: 'share-list', x: 7, y: 15, w: 4, h: 18, static: true },
		{ i: 'horizontal-bar', x: 0, y: 11, w: 10, h: 1, static: true },
	],
	sm: [
		{ i: 'add-storage-label', x: 1, y: 1, w: 3, h: 1.5, static: true },
		{ i: 'add-storage', x: 1, y: 3, w: 2, h: 7, static: true },
		{ i: 'storage-ticket-label', x: 4, y: 1, w: 3, h: 1, static: true },
		{ i: 'open-tickets', x: 4, y: 3, w: 2, h: 7, static: true },
		{ i: 'close-tickets', x: 6, y: 3, w: 2, h: 7, static: true },
		{ i: 'share-list-label', x: 7, y: 13, w: 2, h: 1, static: true },
		{ i: 'storage-graphs', x: 1, y: 13, w: 6, h: 34, static: true },
		{ i: 'share-list', x: 7, y: 15, w: 4, h: 18, static: true },
		{ i: 'horizontal-bar', x: 0, y: 11, w: 10, h: 1, static: true },
	],
	md: [
		{ i: 'add-storage-label', x: 1, y: 1, w: 3, h: 1.5, static: true },
		{ i: 'add-storage', x: 1, y: 3, w: 2, h: 7, static: true },
		{ i: 'storage-ticket-label', x: 4, y: 1, w: 3, h: 1, static: true },
		{ i: 'open-tickets', x: 4, y: 3, w: 2, h: 7, static: true },
		{ i: 'close-tickets', x: 6, y: 3, w: 2, h: 7, static: true },
		{ i: 'share-list-label', x: 7, y: 13, w: 2, h: 1, static: true },
		{ i: 'storage-graphs', x: 1, y: 13, w: 6, h: 34, static: true },
		{ i: 'share-list', x: 7, y: 15, w: 4, h: 18, static: true },
		{ i: 'horizontal-bar', x: 0, y: 11, w: 10, h: 1, static: true },
	],
	lg: [
		{ i: 'add-storage-label', x: 1, y: 1, w: 3, h: 1.5, static: true },
		{ i: 'add-storage', x: 1, y: 3, w: 2, h: 7, static: true },
		{ i: 'storage-ticket-label', x: 4, y: 1, w: 3, h: 1, static: true },
		{ i: 'open-tickets', x: 4, y: 3, w: 2, h: 7, static: true },
		{ i: 'close-tickets', x: 6, y: 3, w: 2, h: 7, static: true },
		{ i: 'share-list-label', x: 7, y: 13, w: 2, h: 1, static: true },
		{ i: 'storage-graphs', x: 1, y: 13, w: 6, h: 34, static: true },
		{ i: 'share-list', x: 7, y: 15, w: 4, h: 18, static: true },
		{ i: 'object-storage', x: 1, y: 32, w: 6, h: 14, static: true },
		{ i: 'horizontal-bar', x: 0, y: 11, w: 10, h: 1, static: true },
	],
};
export const LAYOUT_GRID_STORAGE = {
	xs: [
		{ i: 'delete-storage-image', x: 4, y: 4, w: 4, h: 15, static: true },
		{ i: 'large-text', x: 3.5, y: 21, w: 5, h: 4, static: true },
		{ i: 'small-text', x: 3, y: 26, w: 6, h: 3, static: true },
		{ i: 'back-button', x: 4, y: 32, w: 2, h: 3, static: true },
		{ i: 'next-button', x: 6, y: 32, w: 2, h: 3, static: true },
		{ i: 'delete-input', x: 4, y: 29, w: 4, h: 4, static: true },
	],
	sm: [
		{ i: 'delete-storage-image', x: 4, y: 4, w: 4, h: 15, static: true },
		{ i: 'delete-input', x: 4, y: 29, w: 4, h: 4, static: true },
		{ i: 'large-text', x: 3.5, y: 21, w: 5, h: 4, static: true },
		{ i: 'small-text', x: 3, y: 26, w: 6, h: 3, static: true },
		{ i: 'back-button', x: 4, y: 32, w: 2, h: 3, static: true },
		{ i: 'next-button', x: 6, y: 32, w: 2, h: 3, static: true },
	],
	md: [
		{ i: 'delete-input', x: 4, y: 29, w: 4, h: 4, static: true },
		{ i: 'delete-storage-image', x: 4, y: 4, w: 4, h: 15, static: true },
		{ i: 'large-text', x: 3.5, y: 21, w: 5, h: 4, static: true },
		{ i: 'small-text', x: 3, y: 26, w: 6, h: 3, static: true },
		{ i: 'back-button', x: 3, y: 32, w: 3, h: 3, static: true },
		{ i: 'next-button', x: 6, y: 32, w: 3, h: 3, static: true },
	],
	lg: [
		{ i: 'delete-storage-image', x: 4, y: 4, w: 4, h: 15, static: true },
		{ i: 'large-text', x: 3.5, y: 21, w: 5, h: 4, static: true },
		{ i: 'small-text', x: 3, y: 26, w: 6, h: 3, static: true },
		{ i: 'back-button', x: 4, y: 32, w: 2, h: 3, static: true },
		{ i: 'next-button', x: 6, y: 32, w: 2, h: 3, static: true },
		{ i: 'delete-input', x: 4, y: 29, w: 4, h: 4, static: true },
	],
};

export const LOCATION_THEME = {
	COLOR: {
		ATL: '#df6a2e',
		CHA: '#8060a9',
		HSV: '#416ba9',
		BHM: '#a8ad00',
	},
};
